export const unregisterPushDevice: (
  jwt: string | null | undefined,
) => Promise<void> = async () => undefined

export const retryPendingUnregister = async (): Promise<void> => undefined
